export default __webpack_public_path__ + "static/media/404.8dfd04a8.svg";